import Vue from 'vue'

export default {
  fetchTimeline(payload) {
    return Vue.http.post('app-services/v2/timeline', payload)
  },

  fetchOrderForTimeline(orderId) {
    return Vue.http.get(`app-services/v2/timeline/order/${orderId}`)
  }
}
